
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { COMPANY_INFO, SERVICES, ASSETS } from '../data';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-20 pb-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1: Brand */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="inline-block mb-6 group">
              <img src={ASSETS.logo} alt={COMPANY_INFO.name} className="h-32 transition-transform duration-300 group-hover:scale-105 transform" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Din lokale tømrer i Aalborg og omegn. Vi leverer kvalitetshåndværk til tiden, uanset om det er nyt tag, terrasser eller carporte.
            </p>
            <div className="flex space-x-4">
              <a 
                href={COMPANY_INFO.facebook} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="p-2 bg-slate-800 hover:bg-amber-500 transition-colors rounded-sm"
                aria-label="Følg os på Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Menu</h4>
            <ul className="space-y-4">
              <li><Link to="/" className="text-slate-400 hover:text-white transition-colors">Forside</Link></li>
              <li><Link to="/projekter" className="text-slate-400 hover:text-white transition-colors">Vores projekter</Link></li>
              <li><Link to="/om-os" className="text-slate-400 hover:text-white transition-colors">Om os</Link></li>
              <li><Link to="/kontakt" className="text-slate-400 hover:text-white transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Ydelser</h4>
            <ul className="space-y-4">
              {SERVICES.map((service) => (
                <li key={service.id}>
                  <Link to={`/service/${service.slug}`} className="text-slate-400 hover:text-white transition-colors">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Kontakt Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-slate-400">
                <MapPin size={18} className="text-amber-500 shrink-0 mt-0.5" />
                <span>{COMPANY_INFO.address}</span>
              </li>
              <li className="flex flex-col space-y-2 text-slate-400">
                <div className="flex items-center space-x-3">
                  <Phone size={18} className="text-amber-500 shrink-0" />
                  <a href={`tel:${COMPANY_INFO.phone.simon.replace(/\s/g, '')}`} className="hover:text-white transition-colors">
                    Simon: {COMPANY_INFO.phone.simon}
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone size={18} className="text-amber-500 shrink-0" />
                  <a href={`tel:${COMPANY_INFO.phone.mark.replace(/\s/g, '')}`} className="hover:text-white transition-colors">
                    Mark: {COMPANY_INFO.phone.mark}
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-3 text-slate-400">
                <Mail size={18} className="text-amber-500 shrink-0" />
                <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-white transition-colors">
                  {COMPANY_INFO.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Jensen & Sørensen ApS. CVR {COMPANY_INFO.cvr}</p>
          <p className="mt-4 md:mt-0">Designet med fokus på kvalitet</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
